var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('title',[_vm._v("基本信息")]),_vm._v(" "),_c('GoodsInfoTab',{attrs:{"active":_vm.currentTit}}),_vm._v(" "),_c('GoodsInfoPage',{attrs:{"goodsType":0}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1af1882b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/GoodsFolder/GoodsCommodity/GoodsBasicInfo.vue
// module id = null
// module chunks = 